<div mat-dialog-title class="dialog-info">
    <label class="dialogTitle">
        {{'UNLOCK_SUBMITTED_ESTIMATE' | translate}}
    </label>
    <button type="button" class="btn-close btn-close-white shadow-none crossButtonPosition" [mat-dialog-close]></button>
</div>

<mat-dialog-content class="contentPadding">
    <div class="content-section">
        <p>{{'UNLOCK_SUBMITTED_ESTIMATE_PARAGRAPH' | translate}}</p>
        <p class="reason-label">{{'ENTER_REASON_FOR_RESUBMITTAL' | translate}}</p>
        <mat-form-field appearance="fill" class="full-width">
            <textarea matInput rows="4" [formControl]="reason" [maxlength]="maxNotesLength"></textarea>
        </mat-form-field>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="actionsPadding">
    <button class="openCloseBtn" mat-raised-button color="primary" (click)="unlockEstimate()">{{'OK' | translate}}</button>
    <button class="openCloseBtn" mat-raised-button color="warn" mat-dialog-close>{{'CANCEL' | translate}}</button>
</mat-dialog-actions>